import { createUseStyles } from '@glu/theming';

export const styles = ({ spacing: { unit } }) => ({
  inputsGroup: {
    display: 'flex',
    gap: 1.5 * unit,
    flexWrap: 'wrap'
  },
  groupInput: {
    flexGrow: 1,
    margin: 0
  }
});

export default createUseStyles(styles);
